import React from 'react'
import s from './ModalLeaderboard.module.scss'
import cx from 'classnames'
import BackButton from 'components/BackButton'
import AudioManager from 'scripts/util/AudioManager'
import store from 'store'
import { setState } from 'store/ui'
import { useSelector } from 'react-redux'
import BackgroundCorners from "components/BackgroundCorners";
import Leaderboard from 'components/Leaderboard'
import BgImg from "assets/images/2024-ui/background-1.jpg";
import BgImg2 from "assets/images/2024-ui/background-5.jpg";
import useQuery from "hooks/useQuery";

ModalLeaderboard.defaultProps = {

}

export default function ModalLeaderboard({id, className, onComplete, showPlay}) {
  const lang = useQuery().get("lang") || "en";
  const { showLeaderboard } = useSelector(state => state.ui)

  const translate = {
    heading: {
      en: "Can you beat the top ten?",
      es: "¿Puedes vencer al top 10?"
    },
    ctaButton: {
      en: "Let's play!",
      es: "¡Vamos a jugar!"
    }
  }

  const onPlay = () => {
    AudioManager.playSound('uiAccept')
    onComplete()
  }

  return (
    <div id={id} className={cx(s.ModalLeaderboard, className, {[s.active]: showLeaderboard})}>
      <div className={s.background}>
        <img className={s.bgImg} src={showPlay ? BgImg : BgImg2} alt="" />
        {showPlay && <BackgroundCorners />}
      </div>
      <div className={s.content}>
        <div className={s.contentInner}>
          <p className={s.copy} dangerouslySetInnerHTML={{__html: translate.heading[lang]}}></p>
          <Leaderboard />
          {showPlay &&
            <button className={'md'} onClick={onPlay}>
              {translate.ctaButton[lang]}
            </button>
          }
        </div>
      </div>
      <BackButton onClick={() => {
        AudioManager.playSound('uiSelect')
        store.dispatch(setState({ showLeaderboard: false }))
      }} />
    </div>
  )
}
